export default "__VITE_ASSET__c223b7c7__"